import { getToken } from "../../../shared/utils/common";
import { LayerData } from "../layers/layerData.model";
import { LayerSerializer } from "../serializers/layerSerializer";

export class CommandSaveOverrides {
  async run(adId: string, overrides: any[], files: any) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ads/${adId}/overrides/`;

    const formData = new FormData();
    formData.append("overrides", JSON.stringify(overrides));
    if (files.source && files.source instanceof File) {
      formData.append("source", files.source);
      if (!files.compressedSource) {
        formData.append("compressed_source", files.source);
      }
    }
    if (files.compressedSource && files.compressedSource instanceof File) {
      formData.append("compressed_source", files.compressedSource);
    }
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Token ${getToken()}`,
        },
        body: formData,
      });
      
      if (response) {
        return response
      }

    } catch (error) {
      console.error("Error uploading overrides:", error);
      throw error;
    }
  }

  deserialize(data: any): LayerData {
    const serializer = new LayerSerializer();
    return serializer.deserialize(data);
  }
}
